import * as React from 'react'

import { spacing } from '@thg-commerce/gravity-theme'

import { styled, withTheme } from '../theme'
import { CombinedThemeInterface } from '../'
import { BasketIcon } from '../Header/BasketIcon'

const HeaderContentArea = styled.div<React.HTMLAttributes<HTMLDivElement>>`
  margin: auto;
  height: ${(props) =>
    props.theme.patterns.header.headerLogo.mobile.headerHeight};
  display: flex;
  justify-content: space-around;
  align-items: center;
`

const LogoLink = styled.a`
  display: flex;
  flex: 1;
  justify-content: center;
  margin: 0 ${spacing(2)};
  border: 2px solid transparent;

  svg,
  img {
    height: ${(props) => props.theme.patterns.header.headerLogo.desktop.height};
    width: 100%;
  }

  &:focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.palette.brand.base};
  }
`

const IconWrapper = styled.div`
  a,
  button {
    position: relative;
    text-decoration: none;
    display: flex;
    flex-direction: row;
    width: auto;
    padding: ${spacing(1.25)};
    outline: none;
    border: 2px solid transparent;
    &:focus {
      border: 2px solid ${(props) => props.theme.colors.palette.brand.base};
    }
  }
`

interface AmpHeaderProps {
  theme: CombinedThemeInterface
  uris: {
    search: string
    account: string
    basket: string
    home: string
  }
  itemsInBasket?: number
  i18n: {
    logoLinkAriaLabel: string
    flyoutMenuAriaLabel: string
    searchPlaceholder: string
    accountLabel: string
    basketLabel: string
  }
}

export const AmpHeader = withTheme(
  ({
    theme,
    uris,
    itemsInBasket,
    i18n,
  }: AmpHeaderProps & { theme: CombinedThemeInterface }) => {
    return (
      <HeaderContentArea>
        <IconWrapper>
          <button
            on="tap:flyoutmenu"
            aria-label={i18n.flyoutMenuAriaLabel}
            data-testid="flyout-trigger"
          >
            <amp-img
              height="24px"
              width="24px"
              src="//s1.thcdn.com/enterprise/icons/0.14.1/assets/burger-icon.svg"
              alt=""
            />
          </button>
        </IconWrapper>
        <IconWrapper>
          {/*These tslint ignores are necessary because tslint does not know to 
          check inside amp-imgs when evaluating whether a link will be visible
          to a screen reader. In this case, since the amp-img has alt, it will
          be visible, and does not raise a violation in axe. */}
          {/*tslint:disable:react-a11y-anchors*/}
          <a href={uris.search} data-testid="search">
            <amp-img
              height="24px"
              width="24px"
              src="//s1.thcdn.com/enterprise/icons/0.14.1/assets/search-icon.svg"
              alt={i18n.searchPlaceholder}
            />
          </a>
        </IconWrapper>
        <LogoLink
          aria-label={i18n.logoLinkAriaLabel}
          data-testid="logo-link"
          href={uris.home}
          dangerouslySetInnerHTML={{
            __html:
              ((theme.logo.logoUri || theme.logo.logoAlternateUri) &&
                `<amp-img 
                    src="${theme.logo.logoUri || theme.logo.logoAlternateUri}" 
                    alt="" 
                    height="${theme.patterns.header.headerLogo.mobile.height}" 
                    width="259px" 
                    layout="intrinsic"
                  />`) ||
              theme.logo.logoSVG ||
              '',
          }}
        />
        <IconWrapper>
          {/*tslint:disable:react-a11y-anchors*/}
          <a href={uris.account} data-testid="account">
            <amp-img
              height="24px"
              width="24px"
              src="//s1.thcdn.com/enterprise/icons/0.14.1/assets/account-icon.svg"
              alt={i18n.accountLabel}
            />
          </a>
        </IconWrapper>
        <IconWrapper>
          {/*tslint:disable:react-a11y-anchors*/}
          <a href={uris.basket} data-testid="basket">
            <BasketIcon
              isAmp={true}
              totalQuantity={itemsInBasket}
              altText={i18n.basketLabel}
            />
          </a>
        </IconWrapper>
      </HeaderContentArea>
    )
  },
)
